import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Location } from '@interfaces/rest/interfaces/journey';

@Component({
  selector: 'app-suggestions',
  templateUrl: './suggestions.component.html',
  styleUrls: ['./suggestions.component.scss'],
})
export class SuggestionsComponent {
  @Input() suggestions: any[] = [];
  @Output() sendData = new EventEmitter();

  constructor() { }

  async getAddressByPlaceId(locationSelected: Location) {
    // const suggestionResult = await this.locationService.getAddressByPlaceId(suggestion.placeId);
    // console.log('suggestionResult*****', suggestionResult);
    // if (suggestionResult) {
    // }
    const location: Location = {
      lat: locationSelected.lat,
      lng: locationSelected.lng,
      main: locationSelected.main,
      secondary: locationSelected.secondary
    };

    console.log('location', location);
    this.sendData.emit(location);
    this.suggestions = [];
  }

}
